<template>
  <v-container fluid class="principal-body" color="background" style="height: 100%; overflow-y: auto;">
    <v-row v-if="isAdmin" justify="center">
      <v-col cols="12" align="center" class="pa-0">
        <h2>
          {{ $t('Profile.Platform amount') }}
        </h2>
        <v-text-field
          v-model="platformAmount"
          name="amount"
          type="text"
          :readonly="true"
          class="centered-input pa-0 mt-0 ml-6 mr-6"
          style="font-size: 15pt;padding: 0"
          disabled
        />
      </v-col>
    </v-row>

    <v-row v-if="isAdmin" justify="center">
      <v-col cols="12" align="center" class="pa-0">
        <h5>{{ $t('AdminCommissions.Byppay Commision') }}</h5>
        <v-text-field
          v-model="receiverComission"
          :label="$t('AdminCommissions.Receiver comission')"
          name="receiverComission"
          required
          type="number"
          prepend-icon="mdi-mail"
        />
    
        <v-text-field
          v-model="payerComission"
          :label="$t('Profile.Payer comission')"
          name="payerComission"
          required
          type="number"
          prepend-icon="mdi-mail"
        />
    
        <v-text-field
          v-model="platformComission"
          :label="$t('AdminCommissions.Platform comission')"
          name="platformComission"
          required
          type="number"
          prepend-icon="mdi-mail"
        />

        <v-text-field v-if="false"
          v-model="factorComission"
          :label="$t('Factor comission')"
          name="factorComission"
          required
          type="number"
          prepend-icon="mdi-mail"
        />
      </v-col>

      <v-col cols="12" align="center" class="pa-0">
        <h5>{{ $t('Market Commision') }}</h5>
        <v-text-field
          v-model="percentageInvoicePayer"
          :label="$t('Percentage Invoice Payer')"
          name="percentageInvoicePayer"
          required
          type="number"
          prepend-icon="mdi-mail"
        />

        <v-text-field
          v-model="percentageInvoiceReceiver"
          :label="$t('Percentage Invoice Receiver')"
          name="percentageInvoiceReceiver"
          required
          type="number"
          prepend-icon="mdi-mail"
        />
        <v-text-field v-if="false"
          v-model="userCommission"
          :label="$t('Percentage user commission')"
          name="percentageInvoicePayer"
          required
          type="number"
          prepend-icon="mdi-mail"
        />
        <v-text-field
          v-model="platformCommission"
          :label="$t('Percentage platform commission')"
          name="percentageInvoiceReceiver"
          required
          type="number"
          prepend-icon="mdi-mail"
        />
      </v-col>
      <v-col cols="12" align="center" class="pa-0">
        <h5>{{ $t('Profile.Wallet addresses') }}</h5>
        <v-text-field
          v-model="platformWalletAddress"
          :label="$t('Profile.Wallet address')"
          name="percentageInvoicePayer"
          required
          type="numner"
          prepend-icon="mdi-mail"
        />

        <v-text-field
          v-model="platformStripePrivate"
          :label="$t('chat.stipe-private-key')"
          name="percentageInvoiceReceiver"
          required
          prepend-icon="mdi-mail"
        />
        <v-text-field
          v-model="platformStripePublic"
          :label="$t('chat.stipe-public-key')"
          name="percentageInvoicePayer"
          required
          prepend-icon="mdi-mail"
        />
      </v-col>
      <v-col cols="12" align="center" class="pa-0">
        <h5>{{ $t('Profile.Exange ratios') }}</h5>
        <v-text-field
          v-model="eurToBytoRatio"
          :label="$t('Profile.Euro to byto ratio')"
          name="percentageInvoicePayer"
          required
          type="numner"
          prepend-icon="mdi-mail"
        />
      </v-col>
    </v-row>
    <v-row v-if="isAdmin">
      <v-col cols="12" align="center" class="pa-0">
        <v-btn class="btn-primary" dark depressed x-large @click="saveParameters">
          {{ $t('Save') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiRepository from "@/repositories/ApiRepository";
import Constants from "../../constants";
import SmartRepository from "@/repositories/SmartRepository";

export default {
    name: "AdminCommissions",
    data () {
        return {
            isAdmin: true,
            userCommission: 0,
            platformCommission: 0,
            platformAmount: 0,
            payerComission: 0,
            receiverComission: 0,
            percentageInvoicePayer: 0,
            percentageInvoiceReceiver: 0,
            platformComission: 0,
            factorComission: 0,
            platformStripePublic: '',
            platformStripePrivate: '',
            platformWalletAddress: '',
            eurToBytoRatio: '',
            rules: {
                name: [val => (val || '').length > 0 || this.$t('Error.This field is required')],
                surname: [val => (val || '').length > 0 || this.$t('Error.This field is required')],
                phone: [
                    v => !!v || this.$t('The phone field is required'),
                    v => /^(\+?[\d ]{9,}|)$/.test(v) || this.$t('The phone must be valid')
                ],
                email: [
                    v => !!v || this.$t('Error.The mail field is required'),
                    v => /.+@.+\..+/.test(v) || this.$t('The mail must be valid.')],
                address: [val => (val || '').length > 0 || this.$t('Error.This field is required')],
                cif: [
                    val => (val || '').length > 0 || this.$t('Error.This field is required'),
                    //v => /^[a-zA-Z0-9]{1}[0-9]{7}[a-zA-Z0-9]{1}$/.test(v) || this.$t('The CIF must be valid (Example formats: A12345678, 12345678B, C1234567D)')
                ]
            },
        };
    },
    watch: {
        $parameters: function () {
            this.getParametersComissions();
        }
    },
    created () {
        this.fetch();
    },
    methods: {
        fetch (showErrors = true) {
            this.getParametersComissions();
            this.getMarketParameters();
            this.getWalletParameters();
            this.getExchangeRatios();
            if (this.$user.role === Constants.USER.ROLE_ADMIN) {
                SmartRepository.call(Constants.contractMarketplace, "balanceTokens", [])
                    .then((amount) => {
                        this.platformAmount = SmartRepository.decodeEther(amount).toString();
                    }).catch((e) => {
                        console.error(e);
                        if (showErrors) {
                            if (e.code === "NETWORK_ERROR") {
                                this.$root.$emit('show-snackbar', {
                                    message: this.$t('admin.NETWORK_ERROR'),
                                    color: "error"
                                });
                            } else {
                                let message = e.toString();
                                if (e.message) {
                                    message = e.message;
                                }
                                if (e.data && e.data.message) {
                                    message = e.data.message;
                                }
                                this.$root.$emit('show-snackbar', {message: message, color: "error"});
                            }
                        }
                    });
            }
        },
        saveParameters () {
            ApiRepository.saveParameters(this.payerComission, this.receiverComission, this.platformComission, this.factorComission, this.stripePublicKey, this.stripePrivateKey, this.walletAddress, this.iban, this.percentageInvoicePayer, this.percentageInvoiceReceiver, this.userCommission, this.platformCommission, this.platformWalletAddress, this.platformStripePublic, this.platformStripePrivate, this.eurToBytoRatio)
                .then(() => {
                    ApiRepository.getParameters().then((res) => {
                        if (res && res.data && res.data.params) {
                            this.$parameters = res.data.params;
                        }
                        this.$root.$emit('show-snackbar', {message: "Saved successfully!", color: 'success'});
                    }).finally(() => {
                        this.fetch(false);
                    });
                })
                .catch((err) => {
                    let miss = "";
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAME_CIF) {
                        miss = this.$t('Already exists a user with this CIF');
                    } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAME_MAIL) {
                        miss = this.$t('Already exists a user with this Email');
                    } else {
                        miss = this.$t('Error.Something went wrong');
                    }
                    this.$root.$emit('show-snackbar', {message: miss, color: 'error'});
                    console.error(err);
                });
        },
        getParametersComissions () {
            if (this.$parameters) {
                this.payerComission = this.$parameters.payerComission;
                this.receiverComission = this.$parameters.receiverComission;
                this.platformComission = this.$parameters.platformComission;
                this.factorComission = this.$parameters.factorComission;
                this.percentageInvoicePayer = this.$parameters.percentageInvoicePayer;
                this.percentageInvoiceReceiver = this.$parameters.percentageInvoiceReceiver;
            }
        },
        getMarketParameters () {
            ApiRepository.getParametersMarket().then((res) => {
                this.percentageInvoiceReceiver =  res.data.params.percentageInvoiceReceiver;
                this.percentageInvoicePayer =  res.data.params.percentageInvoicePayer;
                this.userCommission = res.data.params.userCommission;
                this.platformCommission = res.data.params.platformCommission;

            }).catch((err) => {
                this.$root.$emit('show-snackbar', {message: this.$t(err.response.data.errorCode), color: "error"});
                console.log(err);
            });
        },
        getWalletParameters () {
            ApiRepository.getPlatformAccounts().then((res) => {
                this.platformWalletAddress = res.data.accounts.walletAddress;
                this.platformStripePublic = res.data.accounts.stripe.public_key;
                this.platformStripePrivate = res.data.accounts.stripe.private_key;
            }).catch((err) => {
                this.$root.$emit('show-snackbar', {message: this.$t(err.response.data.errorCode), color: "error"});
                console.log(err);
            });
        },
        getExchangeRatios () {
            ApiRepository.getExangeRatios().then((res) => {
                this.eurToBytoRatio = res.data.exangeRatios.eurToByto;
            }).catch((err) => {
                this.$root.$emit('show-snackbar', {message: this.$t(err.response.data.errorCode), color: "error"});
                console.log(err);
            });
        }
    }
};
</script>

<style scoped>

</style>
